import { ReactNode } from 'react'
import { ProgressBar } from 'react-bootstrap'
import './EqxProgressBar.css'

interface EqxProgressBarProps {
    variant?: string
    now?: number
    label?: string
    size?: string
    className?: string
    ghosted?: boolean
    isChild?: boolean
    items?: ReactNode[]
}
const EqxProgressBar = (props: EqxProgressBarProps) => {
    const ghosted = props.ghosted ?? false
    if (props.items) {
        return (
            <ProgressBar
                className={
                    (props.size && 'size-' + props.size + ' ') + (' ' + (props.className ?? '') + ' eqx-progress-bar')
                }
            >
                {props.items}
            </ProgressBar>
        )
    } else {
        return (
            <ProgressBar
                isChild={props.isChild}
                variant={props.variant}
                now={props.now}
                label={props.label}
                className={
                    (props.size ? 'size-' + props.size + ' ' : '') +
                    (ghosted ? 'eqx-progress-ghosted ' : '') +
                    (props.className ? props.className + ' ' : '') +
                    (!props.isChild ? ' eqx-progress-bar ' : '')
                }
            />
        )
    }
}

export { EqxProgressBar as default }

